module.exports = __webpack_public_path__ + "img/back.e3e32450.png";